import * as React from 'react';
import * as ReactDOM from "react-dom";
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {CampusProofCard} from './CampusProofCard';
import {CampusButton} from '../Components/CampusButton';
import {CampusCloseX} from '../Components/CampusCloseX';
import {DesignSelector} from '../DesignSelector/DesignSelector';
import {NewCampusUploadFiles} from '../UploadFiles/NewCampusUploadFiles';

/* root for image */
declare var UploadRoot: string;
declare var AssetRoot: string;

const designBox: React.CSSProperties = {
    height:'300px',
    marginTop:'20px'
}
const designImageStyle: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'BarlowLight',
    color:'#626161',
    fontSize:'15px',
    margin:'10px auto',
}
const designImageStyle1: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'Lulo',
    color:'#626161',
    fontSize:'16px',
    marginBottom:'10px'
}
const uploadStyle: React.CSSProperties = {
    textAlign:'center'
}
const step: React.CSSProperties = {
    textAlign:'center',
    textTransform:'uppercase',
    fontFamily:'Lulo',
    fontSize:'20px'
}
class ArtProps extends Tgcc.BaseProps{
    design: Tgcc.Design;
    uploads: any;
}
class StateType {
    proofId: string;
    uploadedFiles: any;
}
const endsWith = (str: string, suffix: string) => {
    return str.indexOf(suffix, str.length - suffix.length) != 1;
}

class _CampusArtEdit extends React.Component<ArtProps, any>{

    state: StateType = new StateType();

    openDesign = () => {browserHistory.push(Tgcc.Routes.CampusDesignListView)};

    componentWillMount() {
        this.state.uploadedFiles = this.props.uploads || [];
        if(!this.props.state.ActiveProof){
            var newProof = new Tgcc.Proof();
            newProof.phone = this.props.state.UserInfo.phone;
            newProof.smsAllowed = this.props.state.UserInfo.smsAllowed;
            this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: newProof});
        }
    }
    handleUploadDesign = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.UploadDesign})
    }

    canDisplayFile = (name: string) => {
        if(!name)
            return false;
        var test = name.toUpperCase();
        return endsWith(test, '.JPG') || endsWith(test, '.PNG') || endsWith(test, '.TIF') || endsWith(test, '.SVG');
    }

    getImageSource = (fname: string, url: string) => {
        if(this.canDisplayFile(fname))
            return url;

        var test = fname.toUpperCase();
        if(endsWith(test,".PSD"))
            return Tgcc.Styles.uploadImagePlaceholder.PSD;
        if(endsWith(test, ".PDF"))
            return Tgcc.Styles.uploadImagePlaceholder.PDF;
        if(endsWith(test, ".AI"))
            return Tgcc.Styles.uploadImagePlaceholder.AI;
    }
    getUploadsSrc = () => {
        var key = Object.keys(this.props.uploads)[0];
        return this.getImageSource(key, this.props.uploads[key]);
    }

    removeDesign = () => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateCampusProofDesign, payload: null});
    }

    getDesignImage = () => {
        var contents = new Array();
        if(this.props.design){
            var imagepath =  Tgcc.getDesignPath(AssetRoot + this.props.design.thumbnail.replace(' ', '%20'));
            var imgStyle = {maxWidth: '50%', maxHeight:'70%', alignSelf: 'center', marginBottom: '5px', position: 'relative'};
            contents.push(<CampusButton key={1} text="change artwork" onClick={this.openDesign} fontFamily='Lulo' fontSize='15px'lineHeight='1.4em' border='unset' display='flex' alignItems='center' justifyContent='center' margin='auto' width='210px' backgroundColor='#3A54B4' color='white'/>);
            contents.push(<CampusCloseX key={2} closeAction={this.removeDesign}  top="0px" right="0px"/>);
            contents.push(<img key={3} src={imagepath} style={imgStyle} onError={Tgcc.handleDesignImageError}/>);
        }else {
            contents.push(<CampusButton key={1} text="View Designs" onClick={this.openDesign} border='unset' fontFamily='Lulo' fontSize="15px" lineHeight="1.4em" display='flex' margin='auto'  justifyContent='center' alignItems='center' width='210px' backgroundColor='#3A54B4' color='white'/>);
        }
        return contents;
    }
    addUpload = (name: string, url: string) => {
        var oldFiles = this.state.uploadedFiles || {};
        var newFile = {}; newFile[name] = url;
        var newFiles = Object.assign({}, oldFiles, newFile);
        this.setState({uploadedFiles: newFiles});
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: {uploadedFiles: newFiles}});
    }

    removeUpload = (fileUrl: string) => {
        var newFiles = {};
        Object.keys(this.state.uploadedFiles).map( (key) => {
            if(this.state.uploadedFiles[key] != fileUrl)
                newFiles[key] = this.state.uploadedFiles[key];
        });
        this.setState({uploadedFiles: newFiles});
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: {uploadedFiles: newFiles}});
    }

    completeFileUpload = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: null});
    }

    setProofId = (id: string) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: {proofId: id}});
        this.setState({proofId: id});
    }
    checkforDesign(){
        let designImage = this.getDesignImage();
        if (!this.props.design && !this.props.uploads){
            return (
                <div style={designBox} className="innerArtDiv">
                    <div style={designImageStyle1}>SELECT ONE OF OUR DESIGNS</div>
                    {designImage}
                </div>
            )
        }
        else {
            return (<div style={designImageStyle}>{designImage}</div>)
        }      
    }
    getFileUpload(){
        var uploadStr = uploadCt > 1 ? 'total uploads' : 'upload';
        var uploadCt = this.props.uploads ? Object.keys(this.props.uploads).length : 0;  
        var uploadComponent = <div key={3} style={uploadStyle}>{uploadCt} {uploadStr}</div>   
        return (
            <div>
                <NewCampusUploadFiles title="Upload Your Images/ Screenshots/ Artwork Files"
                    proofId={this.state.proofId} 
                    uploadedFiles={this.state.uploadedFiles}
                    addUpload={this.addUpload} 
                    removeUpload={this.removeUpload} 
                    setProofId={this.setProofId}
                    backAction={this.completeFileUpload}
                    state={this.props.state}
                    />
                    {uploadComponent}
            </div>
        )
    }
    render(){  
        var fileUpload = this.getFileUpload();
        var designComp = this.checkforDesign();
        return (
        <div>
            <div style={step}>Step 1</div>
            <CampusProofCard title="DESIGN" margin='0px 10px'containerWidth='375px' innerWidth='335px' containerHeight='470px' innerHeight='402px'>
            {fileUpload}
            {designComp}
            </CampusProofCard>
        </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        design: state.ActiveProof.design,
        uploads: state.ActiveProof.uploadedFiles,
        state:state
    };
};
export var CampusArtEdit = connect(mapStateToProps)(_CampusArtEdit);
